import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Hero } from '../components/Hero';
import { Form } from '../components/Form';

import { Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

export const HolidayLoan = ({hibisId}) => {

  return (
    <>
      <Header />
      <Hero image="oskar-pocitnice.jpg" xPos="30%" yPos="29%" />
      <div className="addiko-app">
        <Container>
            <Row>
                <Col md={6} className="p-3">
                    <h1>Počitnice, kot si jih zaslužite!</h1>
                    <p className="text-left">
                      Ko pride čas za počitnice, naj finance ne bodo ovira.                      
                    </p>
                    <p className="text-left red-text">
                      <b>Z Addiko kreditom lahko enostavno financirate potovanje in si zagotovite sproščen oddih.</b>
                    </p>
                    <p className="text-left">
                      Naj bo vaš dopust brez skrbi in poln lepih spominov. <b>Izpolnite obrazec in kmalu vas bomo poklicali.</b>
                    </p>
                    <p className="text-left text-small">
                        Kjerkoli in kadarkoli, vedno z vami!<br />
                        Addiko banka
                    </p>
                </Col>
                <Col md={1} className="p-3 d-none d-md-block">
                    &nbsp;
                </Col>
                <Col md={5} className="p-3">
                  <Form guid="a247eab1-e16a-45fa-b2c9-53a7dca8f4b6" hibisId={hibisId} />
                </Col>
            </Row>
        </Container>
      </div>      
      <Footer />
    </>
  );
}